import { useMutation } from 'react-query'
import { post } from '../api'
import { Prediction } from '../types/prediction'

import {
  formatFilledWavesToPlot,
  formatIndividualWavesToPlot,
  formatMergedWavesToPlot,
} from '../../utils/dataFormatter'

export const usePrediction = () => {
  return useMutation(
    async (payload: {
      countryName: string
      daysToPredict: string
      metric: string
    }) => {
      const result = await post<{ data: Prediction }, any>('/predictions', {
        ...payload,
        daysToPredict: parseInt(payload.daysToPredict),
      })

      const filledParams = {
        waves: result?.data?.data?.filled?.waves || [],
        limits: result?.data?.data?.waves_limit || [],
        bars: result?.data?.data?.merged?.bars || [],
      }

      const filled = formatFilledWavesToPlot(filledParams)

      const merged = formatMergedWavesToPlot(result.data?.data?.merged || [])

      const individual = formatIndividualWavesToPlot(
        result.data?.data?.individual || []
      )
      return { merged, filled, individual }
    }
  )
}
